// extracted by mini-css-extract-plugin
module.exports = {"notExpandable":"TableUsers_notExpandable__3jOMJ"};